'use strict';
const angular = require('angular');

/*@ngInject*/
export function EFormResultsService($resource) {
  return $resource('/api/e-form-results/:id', {
    name: '@_id'
  },{
    getByForm: {
      method: 'GET',
      url: "/api/e-form-results/form/:id",
      isArray: true
    },
    getBySystemForm: {
      method: 'GET',
      url: "/api/e-form-results/system-form/:name",
      isArray: true
    },
    savePublic: {
      method: 'POST',
      url: "/api/e-form-results/public"
    }
  });
}


export default angular.module('conduu.EFormResultsService', [])
  .factory('EFormResultsService', EFormResultsService)
  .name;



// WEBPACK FOOTER //
// ./client/components/eform-results/eform-results.service.js